__turbopack_context__.v({
  "link": "styles-module__erBiGG__link",
  "selected-link": "styles-module__erBiGG__selected-link",
});
